import { useGetFetch } from '../utils/reactQuery';
import { pathToUrl } from '../utils/router';
import { ApiRoutesEnum } from '../utils/routes';

export type Recommender = {
  id: number;
  value: string;
};

export type FetchRecommendersDictionaryResponseType = Recommender[];

export const useGetRecommendersDictionary = () =>
  useGetFetch<FetchRecommendersDictionaryResponseType>({ url: pathToUrl(ApiRoutesEnum.dictionaryRecommenders) });
